import { render, staticRenderFns } from "./AllTeams.vue?vue&type=template&id=48bf2258&"
import script from "./AllTeams.vue?vue&type=script&lang=ts&"
export * from "./AllTeams.vue?vue&type=script&lang=ts&"
import style0 from "./AllTeams.vue?vue&type=style&index=0&id=48bf2258&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports